import { render, staticRenderFns } from "./channelAttrBrand.vue?vue&type=template&id=64ea88c2&"
import script from "./channelAttrBrand.vue?vue&type=script&lang=ts&"
export * from "./channelAttrBrand.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports